import React, { useMemo, useReducer, createContext } from "react";
import { useCookies } from "react-cookie";
import { setCookie, removeCookie } from "../actionTypes/providers";

export const CookieContext = createContext();

const CookieProvider = ({ children }) => {
  const [cookies, addCookie, clearCookie] = useCookies(["jwtToken"]);
  const [state, dispatch] = useReducer(
    // eslint-disable-next-line consistent-return
    (_prevState, action) => {
      switch (action.type) {
        case setCookie: {
          if (!!action?.value && !!action?.name) {
            addCookie(action?.name, action?.value);
            return {
              [action.name]: action?.value,
            };
          }
          break;
        }
        case removeCookie: {
          if (!!action?.name) {
            clearCookie(action?.name);
            return {
              [action.name]: "",
            };
          }
          break;
        }
        default:
          return {
            ...state,
          };
      }
    },
    {
      jwtToken: cookies?.jwtToken || "",
    }
  );

  const cookieContext = useMemo(
    () => ({
      setCookie: ({ name, value }) =>
        dispatch({ type: setCookie, name, value }),
      removeCookie: ({ name }) => dispatch({ type: removeCookie, name }),
    }),
    []
  );

  return (
    <CookieContext.Provider value={{ cookieContext, ...state }}>
      {children}
    </CookieContext.Provider>
  );
};

export default CookieProvider;
